const appConfig = {
  API_URL: process.env.REACT_APP_BACKEND,
  API_HOST: process.env.REACT_APP_BACKEND_HOST,
};

export default appConfig;
